// extracted by mini-css-extract-plugin
module.exports = {"chartsContainer":"PlayerStats_chartsContainer__3nv7K","chart":"PlayerStats_chart__FLnZ4","chartTitle":"PlayerStats_chartTitle__1GQIS","barChart":"PlayerStats_barChart__3Task"};